import React from 'react';
import classNames from 'classnames';

import TermTooltip from '~components/TermTooltip';

import { TreeTableColumn, TreeTableTreeColumn } from './types';

interface ComponentProps<T> {
  treeColumn: TreeTableTreeColumn<T>;
  columns: TreeTableColumn<T>[];
}

const renderHeader = <T,>({ header, caption }: Pick<TreeTableColumn<T>, 'header' | 'caption'>) =>
  caption ? <TermTooltip id={`tree-table-${caption.id}`} label={header} content={caption.content} /> : header;

/** The `<colgroup>` and `<thead>` built from the column config. */
const TreeTableHeader = <T,>({ treeColumn, columns }: ComponentProps<T>): React.ReactElement => (
  <>
    <colgroup>
      <col key={treeColumn.key} style={{ width: treeColumn.width }} />
      {columns.map(({ key, width }) => (
        <col key={key} style={{ width }} />
      ))}
    </colgroup>
    <thead>
      <tr>
        <th scope="col">{renderHeader(treeColumn)}</th>
        {columns.map((column) => (
          <th key={column.key} scope="col" className={classNames({ 'align-end': column.align === 'end' })}>
            {renderHeader(column)}
          </th>
        ))}
      </tr>
    </thead>
  </>
);

export default TreeTableHeader;
